/**
 * @readonly
 * @enum  {number}
 */
export const AlternateProvisionTypeEnum = {
  None: 0,
  Provision2_Base: 1,
  Provision2_Non_Base: 2,
  CEP: 3,
  NSLP_and_SBP_Alt: 4,
  NSLP_or_SBP_Alt: 5,
  Prov2_Non_Base_Breakfast_Only: 6,
};



// WEBPACK FOOTER //
// ./src/common/Constants/Enumeration/AlternateProvisionTypeEnum.js